export const iconFontAwesomeUsersPeopleStreetView = (
	<i className="fa-solid fa-street-view"></i>
);
